/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';

import { handleApiError, phpApi } from '../../../api';
import { Answers, DownloadResourceActionType } from '../redux/ofwcaPath.types';

// TODO: remove these ANY
export const fetchFormData: () => Promise<any> = (): Promise<any> => (
  phpApi.get('/api/forms/1').catch((): { status: number } => ({ status: 500 }))
);

// TODO: remove these ANY
export const sendAnswers: (answers: Answers) => Promise<any> = (answers: Answers): Promise<any> => phpApi.post(
  '/api/forms/1',
  answers
).catch(handleApiError);

// TODO: remove these ANY
export const fetchRelatedStations: () => Promise<any> = (): Promise<any> => (
  phpApi.get('/api/user/related-dealer-stations').catch(handleApiError)
);

// TODO: remove these ANY
export const generateToken: (hash: string) => Promise<any> = (hash: string): Promise<any> => (
  phpApi.post('/api/forms/1/token/generate-signature-verification', { url: hash }).catch(handleApiError)
);

// TODO: remove these ANY
export const verifyToken: (token: string) => Promise<any> = (token: string): Promise<any> => (
  phpApi.post('/api/forms/1/token/verify', { token }).catch((): { status: number } => ({ status: 422 }))
);

// TODO: remove these ANY
export const uploadFile: (formData: FormData) => Promise<any> = (formData: FormData): Promise<any> => (
  phpApi.post(
    '/api/forms/1/upload',
    formData,
    { customEnv: { notEncryptedRequest: true } }
  ).catch(handleApiError)
);

// TODO: remove these ANY
export const fetchSignedDocuments: () => Promise<any> = (): Promise<any> => (
  phpApi.get('/api/forms/1/documents').catch(handleApiError)
);

// TODO: remove these ANY
export const finishForm: () => Promise<any> = (): Promise<any> => (
  phpApi.post('/api/forms/1/finish').catch(handleApiError)
);

export const downloadResource: (uid: string, resourceType?: DownloadResourceActionType) => Promise<AxiosResponse<Blob>>
  = (uid: string, resourceType: DownloadResourceActionType = 'stream'): Promise<AxiosResponse<Blob>> => (
    phpApi.get(
      `/download/form-uploaded/1/${resourceType}/${uid}`,
      { responseType: 'blob', customEnv: { skipSaveAs: true } }
    )
  );
